<template>
	<div class="character-main-wrapper">
		<div class="debug-info d-none">
			<span>scrollPosition: {{ $scrollStatus.scrollPosition }}</span><br />
			<span>contentSize: {{ $scrollStatus.contentSize }}</span><br />
			<a href="" @click.prevent="toTop">GO_TO_TOP</a><br />
			<a href="" @click.prevent="toBottom">GO_TO_BOTTOM</a><br />
			<a href="" @click.prevent="enableScroll">ENABLE SCROLL</a>
		</div>
		<router-link to="/" class="mobile-logo-link">
			<div class="mobile-logo"></div>
		</router-link>
		<div id="character">
			<component :is="$route.params.name" class="ch-wrapper"></component>
		</div>
		<Loading />
		<IntroHelp :show-modal="(showIntro && $route.params.name != 'villian') || store.showTutorial" />
	</div>
</template>

<script>
import vanessa from './characters/vanessa.vue';
import villian from './characters/villian.vue';
import henry from './characters/henry.vue';
import holly from './characters/holly.vue';
import ozzie from './characters/ozzie.vue';
import helpers from '../util/helpers';
import Loading from './components/Loading.vue';
import IntroHelp from './components/IntroHelp.vue';
import { store } from './store.js'

import '@kouts/vue-modal/dist/vue-modal.css'

export default {
	name: 'Character',
	components: {
		Loading,
		IntroHelp,
		vanessa,
		villian,
		henry,
		holly,
		ozzie
	},
	data() {
		return {
			showIntro: false,
			store,
		};
	},
	created() {
		this.$watch('$route.meta', (newVal) => {
			this.showIntro = newVal.intro;
		}, { immediate: true });
	},
	mounted() {
		this.$watch('$readMore.value', newVal => {
			if (newVal !== '' && window.document.querySelector('.read-icon-wrapper')) {
				window.document.querySelector('.read-icon-wrapper').classList.add('animate');
				setTimeout(() => {
					window.document.querySelector('.read-icon-wrapper').classList.remove('animate');
				}, 1500);
			}
		}, { immediate: true });

		this.$watch('$evidence.value', newVal => {
			if (newVal !== null && window.document.querySelector('.evidence-icon')) {
				window.document.querySelector('.evidence-icon').classList.add('animate');
				setTimeout(() => {
					window.document.querySelector('.evidence-icon').classList.remove('animate');
				}, 1500);
			}
		}, { immediate: true });
		// this.$watch('$tutorial.value', newVal => {
		// 	this.showIntro = !newVal;
		// }, { immediate: true });
	},
	provide() {
		return {
			helpers,
		};
	},
	methods: {
		toBottom() {
			window.scrollTo({
				top: 45000,
				behavior: 'smooth'
			});
		},
		toTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		},
		enableScroll() {
			helpers.enableScrolling();
		}
	}
}
</script>

<style lang="scss">
img {
	max-width: 100%;
	width: auto;
}

.mobile-logo {
	@media(max-width: 600px) {
		background-image: url('/themes/rise-theme/dist/images/estate/about/About_Background_Keys.png');
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		width: 115px;
		height: 135px;
		position: absolute;
		right: 0;
		// top: 0;
		// left: 0;
		// z-index: 5;
	}

	@media(max-width: 400px) {
		width: 75px;
		height: 95px;
	}
}

.strings {
	background-image: url('/themes/rise-theme/dist/images/estate/character-view/strings.png');
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	background-attachment: fixed;
	width: 100%;
	height: 100%;
	position: fixed;
	z-index: 2;
	top: 0;
	pointer-events: none;

	@media(max-width: 1367px) {
		background-image: url('/themes/rise-theme/dist/images/estate/character-view/mobile-red-strings.png?v=1');
		background-attachment: initial;
	}
}

.gallery-icon-wrapper {
	transition: 0.3s;
}

.empty-gallery,
.empty-evidence {
	filter: brightness(0.5);
	pointer-events: none;
}

.player-wrapper {
	&.disabled {
		filter: brightness(0.5);
		pointer-events: none;
	}
}

.evidence-icon {
	cursor: pointer;
	user-select: none;
}

.read-popper {
	max-width: 16vw;

	@media(max-width:600px) {
		max-width: max-content;
	}

	@media (max-width:1024px) and (orientation: landscape) {
		max-width: 60vw;
	}
}

.evidence-popper {
	width: 365px;
	min-height: 20vh;

	@media(max-width: 600px) {
		width: 100%;
	}
}

.player-wrapper.animate,
.read-icon-wrapper.animate,
.evidence-icon.animate {
	animation: pulse 0.5s ease-in 2;
}

@keyframes pulse {
	25% {
		transform: scale(0.9);
	}

	75% {
		transform: scale(1.1);
	}
}

.vm-wrapper {
	.vm-btn-close {
		&:before {
			background-color: red;
			display: inline-block;
			width: 27px;
			height: 27px;
			border-radius: 50%;
			font-size: 30px;
			font-weight: bold;
			line-height: 29px;
			transition: 0.3s;
		}

		&:hover {
			&:before {
				transform: scale(1.2);
			}
		}

		&:active,
		&:focus {
			outline: 0;
		}
	}
}

.vm-wrapper .vm {
	top: auto;
}

.fullscreen-modal {
	width: 70%;
	max-width: 70%;
	margin: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
	background-color: transparent;
	position: absolute;
	top: 50% !important;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
	border-radius: 20px;
	background-color: #000000dd;
	overflow: hidden;

	.vm-titlebar {
		border-bottom-width: 0px;
	}

	.modal-content {
		background-color: transparent;
		height: 100%;
		border: none;
	}
}

.fullscreen-modal .vm-titlebar {
	flex-shrink: 0;
}

.fullscreen-modal .vm-content {
	padding: 0;
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	min-height: 0;
	color: white;
}

.fullscreen-modal .vm-content .scrollable-content {
	position: relative;
	overflow-y: auto;
	overflow-x: hidden;
	padding: 10px 15px 10px 15px;
	flex-grow: 1;
}

@media screen and (max-width: 991px) and (orientation: landscape) {
	/* left panel */
	.microsite-estate-home .character .media-wrapper {
		zoom: 0.8;
	}

	/* right panel */
	.character .controls-button {zoom: 0.6;}

	/* modal */
	//.intro-help .fullscreen-modal {
	//	zoom: 0.5;
	//}

	/* center */
	.character-d .zoom {zoom: 0.4 !important;}
	.character-d .comment-box {
		max-width: 55%;
	    min-width: 55%;
	}
	.character-d .comment-box .exhibit {zoom: 1;}
	.character-d .comment-box span {
		font-size: 0.85rem;
		line-height: 1rem;
	}

	/* right logo */
	.character .desktop-keys {zoom: 0.7;}
	.character .post-mark {zoom: 0.49 !important;}

	/* language */
	.character .cc-control {
		right: 15px;
	    scale: 0.7;
	    bottom: 15px;
	}

	.lang-control {
	    bottom: 22px;
	    right: 55px;
	    scale: 1;
	}

	/* popup */
	#outro {
		zoom: 0.9;
	}

	.v-popper__popper {
		position: fixed !important;
		top: 50% !important;
		left: 50% !important;
		transform: translate(-50%, -50%) !important;
	}
	.v-popper__popper .v-popper__wrapper {
		zoom: 0.5;
	}

	.microsite-estate-home .v-popper__inner .popper-closer {
		right: -30px;
	    top: -35px;
	    font-size: 15px;
	}

	.intro-help .vm-titlebar .vm-btn-close {top: 0;}
	.intro-help .slides-wrapper .help-slide .text {
		font-size: 1rem;
		line-height: 1.2rem;
		min-height: 3rem;
	}
	.intro-help .vm-title {
		font-size: 15px;
		line-height: 20px;
	}
	.intro-help .vm-titlebar .vm-btn-close {line-height: 0;}
	.intro-help .vm-titlebar .vm-btn-close:before {
		font-size: 18px;
		line-height: 32px;
	}

	#popper_cc {
		right: 50%;
		bottom: 20px;
		transform: translate(57%, 0) !important;
		zoom: 0.6;
	}

	.section .logo {
		zoom: 0.5 !important;
		top: 10px !important;
	}
	.section .scroll-down {
		bottom: 20px !important;
		zoom: 0.6;
	}
}

@media screen and (max-width: 700px) and (orientation: landscape) {
	.intro-help .slides-wrapper .help-slide .text {
		font-size: 1rem;
		line-height: 1rem;
		min-height: 2rem;
	}
	.intro-help .vm-title {
		font-size: 20px;
		line-height: 30px;
	}
}

@media screen and (max-width: 568px) and (max-height: 320px) and (orientation: landscape) {
	.intro-help .fullscreen-modal {zoom: 0.4;}
	.intro-help .help-footer {margin-top: 0;}
	.intro-help .vm-content .modal-content {padding-top: 0;}
	.intro-help .tutorial-1 .more {width: 18%;}
}

@media screen and (max-width: 1280px) {
	.modal-tooltip.v-popper__popper.v-popper__popper--shown {
		zoom: 0.7 !important;
	}
}

@media screen and (max-width: 750px) {
	.modal-tooltip.v-popper__popper.v-popper__popper--shown {
		top: initial;
	    left: 15px !important;
	    width: initial;
	    right: initial;
	    transform: translate(0, 0) !important;
	    bottom: 170px;
	    zoom: 0.6 !important;
	}
}
</style>
